module.exports = __webpack_public_path__ + "img/underwrite.3c39257c.png";